// extracted by mini-css-extract-plugin
module.exports = {"pagination":"pagination___3p2JE"};